import type { RouteObject } from "react-router";
import { createElement } from "react";
import "./admin.css";
import { OverviewPage } from "./OverviewPage";
import { MaterialsPage } from "./MaterialsPage";
import { SpeakersPage } from "./SpeakersPage";
import { ClassesPage } from "./ClassesPage";
import { BatchesPage } from "./BatchesPage";
import { QcPage } from "./QcPage";
import { StimuliPage } from "./StimuliPage";
import { QualityPage } from "./QualityPage";
import { ExportPage } from "./ExportPage";
import { UsersPage } from "./UsersPage";
import { AiPage } from "./AiPage";
import { StudentRecordingsPage } from "./StudentRecordingsPage";
import { TaskStudentsPage } from "./TaskStudentsPage";

/** docs/UX.md 11–18. Mounted by `router.tsx` behind `RequireRole course_team|admin`. */
export const routes: RouteObject[] = [
  { path: "/m", element: createElement(OverviewPage) },
  { path: "/m/materials", element: createElement(MaterialsPage) },
  { path: "/m/speakers", element: createElement(SpeakersPage) },
  { path: "/m/speakers/:speakerId/recordings", element: createElement(StudentRecordingsPage) },
  { path: "/m/batches/:batchId", element: createElement(TaskStudentsPage) },
  { path: "/m/classes", element: createElement(ClassesPage) },
  { path: "/m/batches", element: createElement(BatchesPage) },
  { path: "/m/qc", element: createElement(QcPage) },
  // 示范录音（T7 听辨题的参考音）—— 教师 / 课程团队 / 管理员
  { path: "/m/stimuli", element: createElement(StimuliPage) },
  { path: "/m/quality", element: createElement(QualityPage) },
  { path: "/m/export", element: createElement(ExportPage) },
  // 账号管理是 admin 专属；页面内部再用 useAuth 校验并显示「无权限」。
  { path: "/m/ai", element: createElement(AiPage) },
  { path: "/m/users", element: createElement(UsersPage) },
];

export { CoverageHeatmap } from "./CoverageHeatmap";
export { SystemStatusCard } from "./SystemStatusCard";
export {
  OverviewPage,
  MaterialsPage,
  SpeakersPage,
  ClassesPage,
  BatchesPage,
  QcPage,
  StimuliPage,
  QualityPage,
  ExportPage,
  UsersPage,
  AiPage,
};
